import { render, staticRenderFns } from "./DataQualityList.vue?vue&type=template&id=a8215eb6&scoped=true&"
import script from "./DataQualityList.vue?vue&type=script&lang=js&"
export * from "./DataQualityList.vue?vue&type=script&lang=js&"
import style0 from "./DataQualityList.vue?vue&type=style&index=0&id=a8215eb6&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8215eb6",
  null
  
)

export default component.exports